import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(38, 87, 158, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  z-index: 9999;
  padding: 50px 15px;
  overflow-y: auto;
`;

export const Inner = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  max-width: 1080px;
  padding: 50px 70px;
  border-radius: 20px;
  background-color: #fff;
  box-shadow: 20px 7px 40px rgba(0, 0, 0, 0.28);
  z-index: 15;
  h2 {
    color: #333;
    font-size: 40px;
    font-weight: 700;
    padding-right;
  }
  h3 {
    color: #333;
    font-size: 40px;
    font-weight: 400;
    margin-bottom: 30px;
  }
  h4 {
    color: rgba(51, 51, 51, 0.7);
    font-size: 28px;
    font-weight: 800;
    margin-bottom: 30px;
  }

  ul {
    li {
      color: rgba(51, 51, 51, 0.7);
      font-size: 20px;
      line-height: 25px;
      font-weight: 400;
      margin-bottom: 20px;
      white-space: pre-line;
      b {
        font-weight: 800;
        font-size: 22px;
      }
      a {
        color: currentColor;
        text-decoration: none;
        &:hover {
          text-decoration: underline;
        }
      }
      &.paraapoioar,
      &.coordenacao {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        & > span {
          padding-left: 10px;
        }
      }
    }
  }
  @media (max-width: 992px) {
    padding: 30px 40px;
    h2 {
      font-size: calc(100vw / 18);
      margin-bottom: 15px;
    }
    h3 {
      font-size: calc(100vw / 23);
    }
  }
  @media (max-width: 992px) {
    padding: 30px 40px;
    h2 {
      font-size: 22px;
    }
    h3 {
      font-size: 17px;
    }
    ul {
      li {
        font-size: 16px;
        b {
          font-size: 16px;
        }
      }
    }
  }
`;
export const TextInner = styled.div`
  color: rgba(51, 51, 51, 0.7);
  font-size: 20px;
  font-weight: 300;
  white-space: pre-line;
  margin-bottom: 30px;
  @media (max-width: 992px) {
    font-size: 16px;
    line-height: 1.5;
  }
`;
export const CloseBtn = styled.button`
  position: absolute;
  width: 43px;
  height: 43px;
  top: 0;
  right: 0;
  cursor: pointer;
  background-color: transparent;
  border: 0;
  margin-top: 40px;
  margin-right: 40px;
  /* background-color: #999; */
  &:before,
  &:after {
    content: '';
    display: block;
    position: absolute;
    background-color: rgba(245, 167, 160, 1);
    width: 100%;
    height: 4px;
    top: 50%;
    left: 50%;
  }
  &:before {
    transform: translate(-50%, -50%) rotate(45deg);
  }
  &:after {
    transform: translate(-50%, -50%) rotate(-45deg);
  }
  @media (max-width: 992px) {
    margin: 0;
    width: 55px;
    height: 55px;
    &:before,
    &:after {
      width: 60%;
    }
  }
`;

export const Highlight = styled.div`
  /* background-color: #014596; */
  background-color: #fff3cd;
  border-radius: 7px;
  font-weight: 700;
  font-size: 16px;
  /* color: #fff; */
  color: #856404;
  padding: 20px 35px 10px;
  margin-bottom: 30px;
  b {
    display: flex;
    align-items: center;
    svg {
      margin-right: 10px;
    }
  }
  ul {
    list-style: disc;
    padding: 15px 30px 0;
    li {
      font-size: 14px;
      /* color: #fff; */
      color: #856404;
      font-weight: 400;
      margin-bottom: 10px;
    }
  }
`;
